import { filtersContext } from '@/components/providers/FiltersProvider/filters-provider.context';
import type { FiltersContext } from '@/components/providers/FiltersProvider/filters-provider.types';
import type { Context } from 'react';
import { useContext } from 'react';

export const useFilters = <TValues = object>() =>
  useContext(filtersContext as unknown as Context<FiltersContext<TValues>>);
